import React, { Component } from 'react'
import {
  Header,
  Divider,
  Grid,
  Checkbox,
  Table,
  Statistic
} from 'semantic-ui-react'
import AdminLayout from '../components/AdminLayout'
// redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  adminGetLowInventory,
  adminGetOrderStats,
  adminGetSettings,
  adminSetSetting
} from '../actions/admin'

class Dashboard extends Component {
  componentWillMount() {
    this.props.adminGetOrderStats()
    this.props.adminGetSettings()
  }
  handleCheckboxChange(id, value) {
    this.props.adminSetSetting(id, value)
  }
  render() {
    const {
      orderStats,
      settings,
      isDashboardLoading,
      isSettingsLoading
    } = this.props.admin
    const { pending, approved } = orderStats
    return (
      <AdminLayout isLoading={isDashboardLoading || isSettingsLoading}>
        <Header as="h3">Dashboard</Header>
        <Divider />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Statistic.Group widths={2}>
                <Statistic label="Pending Orders" value={pending} />
                <Statistic label="Approved Orders" value={approved} />
              </Statistic.Group>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Header as="h3">Settings</Header>
              <Divider />
              <Table definition>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>On/Off</Table.HeaderCell>
                    <Table.HeaderCell>Setting Name</Table.HeaderCell>
                    <Table.HeaderCell>Setting Description</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {settings
                    ? settings.map(({ id, name, value, description }) => {
                        return (
                          <Table.Row>
                            <Table.Cell collapsing>
                              <Checkbox
                                slider
                                checked={value === 'true'}
                                onChange={() => {
                                  this.handleCheckboxChange(
                                    id,
                                    !(value === 'true')
                                  )
                                }}
                              />
                            </Table.Cell>
                            <Table.Cell>
                              {name}
                            </Table.Cell>
                            <Table.Cell>
                              {description}
                            </Table.Cell>
                          </Table.Row>
                        )
                      })
                    : null}
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AdminLayout>
    )
  }
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      adminGetLowInventory,
      adminGetOrderStats,
      adminGetSettings,
      adminSetSetting
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)



// WEBPACK FOOTER //
// ./src/pages/Dashboard.jsx